import React from "react";
import { connect } from "react-redux";

import Content from "../common/template/content";
import ContentCard from "../common/template/contentCard";
import ContentCardBody from "../common/template/contentCardBody";

const AccessDenied = ({ usuarioLogado }) => {
    if (!usuarioLogado) return null;

    return (
        <Content>
            <ContentCard>
                <ContentCardBody
                    style={{
                        minHeight: "calc(100vh - 140px)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                    }}
                >
                    O acesso ao módulo solicitado não está autorizado para este usuário
                </ContentCardBody>
            </ContentCard>
        </Content>
    );
};

const mapStateToProps = (state) => ({
    usuarioLogado: state.auth.usuarioLogado,
});

export default connect(mapStateToProps)(AccessDenied);
